<template>
  <div
    class="topic-block"
    :class="{ error: mark === 2, correct: mark === 1, done: mark === 3 }"
  >
    <div class="mark"></div>
    <div class="topic-number van-ellipsis">{{ indexVal }}题</div>
  </div>
</template>

<script>
export default {
  name: "TopicBlock",
  props: {
    mark: {
      //0默认灰色，1正确，2错误,3黄色（已做）
      type: Number,
      default: 0
    },
    index: {
      type: Array,
      default: function() {
        return [0];
      }
    }
  },
  computed: {
    // 计算属性的 getter
    indexVal: function() {
      let len = this.index.length;
      if (len === 1) {
        return this.index[0];
      }
      if (len > 1) {
        return this.index[0] + "-" + this.index[len - 1];
      }
      return "";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.topic-block {
  width: 22%;
  height: 36px;
  overflow: hidden;
  background: #f3f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  &.error {
    .mark {
      background-image: url("img/error.png");
    }
  }
  &.correct {
    .mark {
      background-image: url("img/correct.png");
    }
  }
  &.done {
    background: #fff7ed;
    .mark {
      background: #ff9100;
    }
  }
  .mark {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #969fa9;
    margin: 0 6px;
    background-size: 100% 100%;
  }
  @media screen and (max-width: 320px) {
    .mark {
      width: 8px;
      height: 8px;
    }
  }

  .topic-number {
    flex: 1;
    font-size: 12px;
    color: #222;
  }
}
</style>
